import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { IPartMediaDocument } from 'parts/types';

import { DefaultCheckbox } from './DefaultCheckbox';

interface IProps {
  document: IPartMediaDocument;
  canMakeDefault: boolean;
  onMakeDefault: (fileId: number) => void;
}

const DocumentExtraInfoBase = ({ document, canMakeDefault, onMakeDefault }: IProps) => {
  const { t } = useTranslation();

  const isDefault = !!document.isDefault;

  if (!isDefault && (!canMakeDefault || !document.fileId)) {
    return null;
  }

  return (
    <DefaultCheckbox
      isDefault={isDefault}
      defaultLabel={t('labelDefaultDatasheet')}
      makeDefaultLabel={t('labelMakeAsDefault')}
      onMakeDefault={
        canMakeDefault && document.fileId ? () => onMakeDefault(document.fileId) : undefined
      }
    />
  );
};

export const DocumentExtraInfo = memo(DocumentExtraInfoBase);
